import { NumberField, TextField } from "react-admin";

import { DataKind, Resource } from "../../types";
import {
  CustomDateTimeField,
  CustomReferenceField,
  CustomShow,
  JsonField,
  ShowTable,
} from "../custom";

function ManualWorkerShow() {
  return (
    <CustomShow
      checkPermissionFor={DataKind.ManualWorker}
      displayDelete={false}
      displayEdit={false}
    >
      <ShowTable title="Manual Worker Details">
        <TextField label="Id" source="id" />
        <TextField label="Name" source="name" />
        <TextField label="Status" source="status" />
        <NumberField
          label="Failed Attempts Made"
          source="failed_attempts_made"
        />
        <JsonField label="Payload" source="payload" />
        <CustomReferenceField
          label="Creator Admin User"
          source="creator_admin_user_id"
          reference={Resource.AdminUser}
        >
          <TextField source="email" />
        </CustomReferenceField>
        <CustomDateTimeField label="Created At" source="created_at" />
        <CustomDateTimeField label="Ended At" source="ended_at" />
        <CustomDateTimeField label="Started At" source="started_at" />
        <CustomDateTimeField label="Updated At" source="updated_at" />
      </ShowTable>
    </CustomShow>
  );
}

export default ManualWorkerShow;
